import { React, useState, useEffect, useContext } from "react";
import PCModal from "../PCModal";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";

function CodeUpdateModal({ title, onClose, handleViewSub, CodeSeq, originRows, MenuUpdateYN, MenuDeleteYN }) {
  const appStore = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [updateRows, setUpdateRows] = useState([]);
  const [columns, setColumns] = useState([]);
  
  // Grid정의
  const handleSetting = () => {
    setColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === "Y"? "error" : "#808080"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === "Y"? false : true } />
            : (MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {AddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === "Y"? "error" : "#808080"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === "Y"? false : true } />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'code_detail_seq', width: 0, headerAlign: 'center' },
      { field: 'code_seq', headerName: 'code_seq', width: 0, headerAlign: 'center' },
      { field: 'code_detail_update_yn', headerName: 'code_detail_update_yn', width: 0, headerAlign: 'center' },
      { field: 'code_detail_name', headerName: '상세코드명', width: 170, headerAlign: 'center', editable: true },
      { field: 'code_detail_desc', headerName: '상세코드설명', width: 220, headerAlign: 'center', editable: true },
      { field: 'code_detail_order', headerName: '순서', width: 70, headerAlign: 'center', align:'right', type:'number', editable: true },
      { field: 'code_detail_value', headerName: '상세코드값1', width: 100, headerAlign: 'center', align:'left', editable: true },
      { field: 'code_detail_value2', headerName: '상세코드값2', width: 100, headerAlign: 'center', align:'left', editable: true },
      { field: 'code_detail_value3', headerName: '상세코드값3', width: 100, headerAlign: 'center', align:'left', editable: true },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
  }

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    code_seq: false,
    actions: true,
    code_detail_update_yn: false,
    code_detail_name: true,
    code_detail_desc: true,
    code_detail_order: true,
    code_detail_value: true,
    code_detail_value2: true,
    code_detail_value3: true,
    reg_user_name: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setColumnVisibilityModel({
      id: false,
      code_seq: false,
      actions: true,
      code_detail_update_yn: false,
      code_detail_name: true,
      code_detail_desc: true,
      code_detail_order: true,
      code_detail_value: true,
      code_detail_value2: true,
      code_detail_value3: true,
      reg_user_name: true,
      row_type: false,
      update_type: false
    });
  }, []);

  useEffect(() => {
    setUpdateRows([]);
    if(typeof originRows !== 'undefined'){
      let array = [];
      for(let i=0; i<originRows.length; i++){
        array.push(Object.assign({}, originRows[i], { code_seq: Number(CodeSeq), row_type: 'O', update_type : 'N'}));
      }
      setRows(array);
    }
  }, [originRows]);

  useEffect(() => {
    // rows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<rows.length; i++){
      if(rows[i].row_type === 'A' && rows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN === 'Y'){
      setRows((rows) => [...rows, { 
        id: Number(appStore.getMaxListID(rows))+1,
        code_seq: Number(CodeSeq),
        code_detail_update_yn: 'Y',
        code_detail_type: 'P',
        code_detail_type_name: '업체자체추가',
        code_detail_name: '',
        code_detail_desc: '',
        code_detail_order: '',
        code_detail_value: '',
        code_detail_value2: '',
        code_detail_value3: '',
        reg_user_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [rows]);

  const processRowUpdate = (newRow, oldRow) => {
    // newRow -> editRow
    // oldRow -> oldRow
    // originRows -> 기존Row
    // updateRows -> 변경Row
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.code_detail_name !== oldRow.code_detail_name || newRow.code_detail_desc !== oldRow.code_detail_desc || newRow.code_detail_order !== oldRow.code_detail_order || newRow.code_detail_value !== oldRow.code_detail_value || newRow.code_detail_value2 !== oldRow.code_detail_value2 || newRow.code_detail_value3 !== oldRow.code_detail_value3){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_code_detail_name = '';
      var row_code_detail_desc = '';
      var row_code_detail_order = '';
      var row_code_detail_value = '';
      var row_code_detail_value2 = '';
      var row_code_detail_value3 = '';

      if(String(newRow.row_type) === "A"){
        //originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if((newRow.code_detail_name).trim() !== '' || (newRow.code_detail_desc).trim() !== '' || newRow.code_detail_order !== '' || (newRow.code_detail_value).trim() !== '' || (newRow.code_detail_value2).trim() !== '' || (newRow.code_detail_value3).trim() !== ''){
          
          row_code_detail_name = (newRow.code_detail_name).trim();
          row_code_detail_desc = (newRow.code_detail_desc).trim();
          row_code_detail_order = newRow.code_detail_order;
          row_code_detail_value = (newRow.code_detail_value).trim();
          row_code_detail_value2 = (newRow.code_detail_value2).trim();
          row_code_detail_value3 = (newRow.code_detail_value3).trim();
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        // console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        originRows.map((data) => data.id === newRow.id
          && ((data.code_detail_name).trim() !== (newRow.code_detail_name).trim() || (data.code_detail_desc).trim() !== (newRow.code_detail_desc).trim() || data.code_detail_order !== newRow.code_detail_order || (data.code_detail_value).trim() !== (newRow.code_detail_value).trim() || (data.code_detail_value2).trim() !== (newRow.code_detail_value2).trim() || (data.code_detail_value3).trim() !== (newRow.code_detail_value3).trim())?
          (
            row_code_detail_name = (data.code_detail_name).trim(),
            row_code_detail_desc = (data.code_detail_desc).trim(),
            row_code_detail_order = data.code_detail_order,
            row_code_detail_value = (data.code_detail_value).trim(),
            row_code_detail_value2 = (data.code_detail_value2).trim(),
            row_code_detail_value3 = (data.code_detail_value3).trim()
          ):""
        )
      }
      
      if((row_code_detail_name).trim() === '' && (row_code_detail_desc).trim() === '' && row_code_detail_order === '' && (row_code_detail_value).trim() === '' && (row_code_detail_value2).trim() === '' && (row_code_detail_value3).trim() === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          // console.log('[updateRows 원복] ' + updateRows.length);
          setUpdateRows(updateRows.filter((data) => data.id !== newRow.id));
          setRows(rows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateRows.length; i++) {
          if(updateRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateRows.length);
          setUpdateRows(updateRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setRows(rows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateRows.length);
          setUpdateRows(prevRows => [...prevRows, newUpdateDataArray]);
          setRows(rows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const DeleteClick = (object) => {
    //updateRows에 ID값이 있을수도 없을수도 있어서 무조건 삭제하고 추가함.
    setUpdateRows((updateRows) => updateRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateRows(prevRows => [...prevRows, {
        id: object.row.id,
        code_seq: Number(CodeSeq),
        code_detail_update_yn: (object.row.code_detail_update_yn).trim(),
        code_detail_type: (object.row.code_detail_type).trim(),
        code_detail_type_name: (object.row.code_detail_type_name).trim(),
        code_detail_name: (object.row.code_detail_name).trim(),
        code_detail_desc: (object.row.code_detail_desc).trim(),
        code_detail_order: object.row.code_detail_order,
        code_detail_value: (object.row.code_detail_value).trim(),
        code_detail_value2: (object.row.code_detail_value2).trim(),
        code_detail_value3: (object.row.code_detail_value3).trim(),
        row_type:'O',
        update_type: 'D'
      }]);
    }

    setRows((rows) => rows.filter((data) => data.id !== object.row.id));
  }

  const AddClick = (object) => {
    // 상세코드 추가
    setRows((rows) => [...rows, { 
      id: Number(appStore.getMaxListID(rows))+1,
      code_seq: Number(CodeSeq),
      code_detail_update_yn: 'Y',
      code_detail_type: 'P',
      code_detail_type_name: '업체자체추가',
      code_detail_name: '',
      code_detail_desc: '',
      code_detail_order: '',
      code_detail_value: '',
      code_detail_value2: '',
      code_detail_value3: '',
      reg_user_name: '',
      row_type:'A',
      update_type: 'N'
    }]);
  }

  const handleSave = () => {
    let msg = '';
    if(updateRows.length > 0){
      for (let i = 0; i < updateRows.length; i++) {
        if((updateRows[i].code_detail_name).trim() === ''){
          msg = '상세코드명은 필수 입력 값 입니다.'
        }
      }

      if(msg === ''){
        for(let i = 0; i < rows.length; i++) {
          const currElem = (rows[i].code_detail_name).trim();
          for(let j = i+1; j < rows.length; j++) {
            if(currElem === (rows[j].code_detail_name).trim()) {
              msg = '중복된 상세코드명이 존재합니다.<br/>[중복된 상세코드명 : '+currElem+']';
              break;
            }
          }
          if(msg !== '')  {
            break;
          }
        }
      }
    }else{
      msg = "변경된 상세코드가 존재하지 않습니다.";
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">상세 코드 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Code/Update", {updateRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '상세 코드 수정 완료',
            text: '정상적으로 상세 코드가 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleViewSub(CodeSeq);
          });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });

    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height : 'auto', width: '960px', overflowY: 'auto'}}>
          <div style={{ padding: '10px', height: '310px' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                columnVisibilityModel={columnVisibilityModel}
                editMode='cell'  
                processRowUpdate={processRowUpdate}        
                onProcessRowUpdateError={(error) => error}
                AlternatingRowBackground="LavenderBlush"
                rowsPerPageOptions={[20, 50, 100]}
                initialState={{ 
                    density: 'compact'
                }}
                slots={{
                    noRowsOverlay: GridNoRow,
                }}
                isCellEditable={(params) => params.row.code_detail_update_yn === 'Y'}
                disableColumnSorting
              />
          </div>
          <div className="modal_action" style={ { padding: '0px' } }>
            <div className="modal_button" style={ { paddingBottom: '12px'} }>
              <Button 
                onClick={handleSave}
                className="btn-p btn-u"
                sx={{  
                    m: 1, 
                    fontSize: 18, 
                    color: "white", 
                    borderColor: "#FF3636", 
                    backgroundColor: "#FF3636",
                    margin: '0px 10px',
                    ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                }} 
                variant="outlined">
                수정
              </Button>
              <Button 
                onClick={()=> { onClose?.(); }}
                className="btn-p"
                sx={{  
                    m: 1, 
                    fontSize: 15, 
                    color: "white", 
                    borderColor: "#808080", 
                    backgroundColor: "#808080",
                    margin: '0px 10px',
                    ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                }} 
                variant="outlined">
                닫기
              </Button>
            </div>
          </div>
        </div>
    </PCModal>
  );
}

export default CodeUpdateModal;